import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[ngxTrimWhitespaces]',
})
export class TrimWhitespacesDirective {
  constructor(
    private el: ElementRef,
    private control: NgControl,
  ) {}

  @HostListener('input')
  onInput() {
    const value = this.el.nativeElement.value;
    const trimmedValue = value?.trim();

    if (value !== trimmedValue) {
      this.el.nativeElement.value = trimmedValue;

      // Update Angular form model
      this.control?.control?.setValue(trimmedValue);
    }
  }
}
